import 'tiny-slider/dist/tiny-slider.css'
import dynamic from 'next/dynamic'
import { useHatch } from '@/modules/hatch/hooks/useHatch'
import { Fields, useTranslation } from '@hako/core'

const TinySlider = dynamic(
    () => import('tiny-slider-react').then((mod) => mod.default),
    {
        ssr: false,
    }
)

export const HatchOffers = () => {
    const { offers, isLoading } = useHatch()
    const { t } = useTranslation('common')

    if (isLoading) {
        return (
            <div className="loader">
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }

    return (
        <TinySlider
            settings={{
                autoplay: false,
                controls: false,
                nav: false,
                mouseDrag: true,
                swipeAngle: false,
                speed: 400,
                lazyload: true,
                responsive: {
                    0: {
                        items: 3,
                        edgePadding: 50,
                        gutter: 16,
                        autoWidth: true,
                        center: true,
                        swipeAngle: false,
                    },
                    768: {
                        items: 4,
                        gutter: 24,
                        edgePadding: 16,
                        center: false,
                        autoWidth: false,
                    },
                },
            }}
        >
            {offers.map((offer) => (
                <div key={offer.purchaseLink}>
                    <div className="box box--center">
                        <div className="box__content">
                            <div>
                                <img src={offer.logo} alt="" />
                            </div>
                            <span>{offer.price}</span>
                            <div
                                className={`status ${
                                    !offer.isAvailable ? 'status--out' : ''
                                }`}
                            >
                                {offer.isAvailable ? (
                                    <Fields.Text
                                        key={offer.isAvailable}
                                        editable={false}
                                        as="span"
                                        scope="global"
                                        slug="stock-status-in-stock"
                                    >
                                        In stock
                                    </Fields.Text>
                                ) : (
                                    <Fields.Text
                                        key={offer.isAvailable}
                                        editable={false}
                                        as="span"
                                        scope="global"
                                        slug="stock-status-out-of-stock"
                                    >
                                        Out of stock
                                    </Fields.Text>
                                )}
                            </div>
                            <a
                                href={offer.purchaseLink}
                                target="_blank"
                                rel="noreferrer nofollow"
                            >
                                <button className="btn btn--primary btn--light">
                                    <Fields.Text
                                        editable={false}
                                        as="span"
                                        scope="global"
                                        slug="buy-now-button-active"
                                    >
                                        Buy now
                                    </Fields.Text>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </TinySlider>
    )
}
